import { Component, EventEmitter, forwardRef, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { TextAreaModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { CardModule, GridLayoutModule } from '@progress/kendo-angular-layout';
import { SelectFieldComponent } from '../select-field/select-field.component';
import { faSave } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-ask-for-help',
    imports: [
        GridLayoutModule,
        LabelModule,
        ButtonModule,
        TranslateModule,
        ReactiveFormsModule,
        TextBoxModule,
        TextAreaModule,
        LoaderModule,
        FontAwesomeModule,
        CardModule,
        forwardRef(() => SelectFieldComponent)
    ],
    templateUrl: './ask-for-help.component.html',
    styleUrl: './ask-for-help.component.css'
})
export class AskForHelpComponent implements OnInit {

  @Output() submitForm: EventEmitter<FormGroup> = new EventEmitter();

  form: FormGroup;
  isNew: boolean;

  saving: boolean = false;
  saveIcon = faSave;

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.form = this.fb.group({
      reasonForContact: ['', Validators.required],
      message: ['', Validators.required],
      orderNum: [''],
      sourceUrl: [''],
      organization: ['']
    })
  }

  save(): void {
    this.saving = true;
    this.submitForm.emit(this.form);
  }

}
